/* eslint-disable perfectionist/sort-imports */
import "@solvari/common-fe/polyfills";

import "./utils/sentry";
import "./utils/argus";
/* eslint-enable perfectionist/sort-imports */

import { initInteractionTracking } from "@solvari/common-fe/argus/thick-client";
import { initFontAwesome } from "@solvari/common-fe/integrations";

import { initCookiePopup } from "@solvari/components";

import { initExpertVueIslands } from "@/scripts/components/vueIslands";
import { initGtmLinkTracking } from "@/scripts/utils/gtmLinkTracking";

import { lazyLoadIntersection } from "./utils/lazyLoadIntersection.js";

import "./components/fitty.js";
import "./components/fontAwesomeLists.js";
import "./components/headerMobile";
import "./components/popupHandler.js";
import "./utils/linkPrefetch.js";

initCookiePopup();
initInteractionTracking();
initGtmLinkTracking();
initFontAwesome();
initExpertVueIslands();
lazyLoadIntersection();
